export {
  checkIsIntercomEnabled,
  openIntercomMessenger,
  openIntercomTicketsPortal,
  shutdownIntercomMessenger,
} from './intercomService';
